<template>
  <v-row class="align-center justify-center login pa-4 ma-0">
    <v-col class="col-12 col-sm-9 col-md-6 col-lg-4">
      <h3 class="gray--text">{{ $t("pageLogin.title") }}</h3>
      <v-form v-model="valid">
        <v-row class="no-gutters">
          <v-col class="col-3">
            <v-subheader>Email</v-subheader>
          </v-col>
          <v-col class="col-8">
            <v-text-field
              solo
              flat
              v-model="email"
              label="Email"
              :rules="[rules.email, rules.required]"
              required
              :placeholder="$t('pageLogin.placeholdEmail')"
              background-color="#F7F7F7"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="no-gutters">
          <v-col class="col-3">
            <v-subheader>{{ $t("pageLogin.labelPassword") }}</v-subheader>
          </v-col>
          <v-col class="col-8">
            <v-text-field
              solo
              flat
              v-model="password"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :type="show1 ? 'text' : 'password'"
              label="Password"
              :rules="[rules.required]"
              required
              :placeholder="$t('pageLogin.placeholdPassword')"
              @click:append="show1 = !show1"
              background-color="#F7F7F7"
              @keyup.enter="login()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <p class="body-1 text-center gray--text">
        {{ $t("pageLogin.mensagem") }}
        <!-- <router-link to="/sign-up" class="grey--text text--darken-2">Clique aqui</router-link>. -->
        <ForgotPassword />
      </p>

      <v-row class="justify-center">
        <v-col class="col-5 col-md-4">
          <v-btn
            color="secondary"
            depressed
            large
            block
            @click="login()"
            :loading="loader"
            :disabled="!valid"
          >ENTRAR</v-btn>
        </v-col>
      </v-row>

      <v-row class="justify-center grey lighten-4 py-4 mt-5">
        <v-col class="col-8">
          <p class="text-center mb-0 gray--text">Não possui uma conta?</p>
          <p class="text-center mb-0">
            <router-link to="cadastro" class="text-uppercase">{{$t("pageLogin.cadastrar")}}</router-link>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { login } from '../services/general';
import ForgotPassword from './ForgotPassword';

export default {
  name: 'ComponentLogin',
  components: {
    ForgotPassword,
  },
  data() {
    return {
      valid: false,
      show1: false,
      loader: false,
      email: '',
      password: '',
      rules: {
        required: value => !!value || 'Esse campo é obrigatiório.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'E-mail invalido.';
        },
      },
    };
  },
  created() {
    console.log(navigator.language);
    // localStorage.setItem('user-locale', 'fr');
    // this.$i18n.locale = localStorage.getItem('user-locale');
  },
  methods: {
    async login() {
      this.loader = true;
      try {
        const result = await login(this.email, this.password);
        const { data } = result;
        this.emitData(data);
      } catch (err) {
        this.emitData(err);
      } finally {
        this.loader = false;
      }
    },
    emitData(v) {
      this.$emit('data', v);
    },
  },
};
</script>

<style lang="scss" scoped>
    .v-subheader {
        background-color: #F7F7F7;
    }
</style>
